enum EOrderSummaryTypes {
  ORDER_SUMMARY_SET_DATA = 'OrderSummary/SET_DATA',
}

export default EOrderSummaryTypes;
